<template>
	<div class="main module-dashboard dashboard">

		<div class="two-columns">

		<div class="thumbnail-container">
			<div class="thumbnail">
				<iframe v-if="dealerDomain" :src="dealerDomain + '?preview=1'" frameborder="0"></iframe>
			</div>
		</div>

		<div class="dashboard-tiles">

			<div class="dashboard-tile web">
				<div class="dashboard-tile-title">Site Template</div>
				<div class="statistics">
					<div class="dashboard-tile-stat">{{ templateDescription }}</div>
					<div class="dashboard-tile-caption">Published</div>
				</div>
				<router-link tag="button" to="/website/template-manager" class="dashboard-link">Website Template</router-link>
			</div>

			<div class="two-columns">

			<div class="dashboard-tile web">
				<div class="dashboard-tile-title">Marquees</div>
				<div class="statistics">
					<div class="dashboard-tile-stat">{{ marqueeCount }}</div>
					<div class="dashboard-tile-caption">Active marquees</div>
				</div>
				<router-link tag="button" to="/website/marquees" class="dashboard-link">Marquees</router-link>
			</div>
			<div class="dashboard-tile web">
				<div class="dashboard-tile-title">Featured Products</div>
				<div class="statistics">
					<div class="dashboard-tile-stat">{{ featuredProductCount }}</div>
					<div class="dashboard-tile-caption">Active featured products</div>
				</div>
				<router-link tag="button" to="/website/featured-products" class="dashboard-link">Featured Products</router-link>
			</div>

		</div>

		</div>
	</div>
	</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			dealerDomain: '',
			templateDescription: '',
			marqueeCount: '',
			featuredProductCount: ''
		}
	},
	created() {
		if (location.hostname.indexOf('.test') > -1) {
			this.dealerDomain = 'https://cds.test'
		} else {
			this.dealerDomain = location.protocol + '//' + location.hostname
		}
		this.getDashboardStats()
	},
	methods: {
		getDashboardStats() {
			this.apiCall({ destination: 'get_website_dashboard_stats' }).then(obj => {
				this.templateDescription = obj.template_description
				this.marqueeCount = obj.marquee_count
				this.featuredProductCount = obj.featured_product_count
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>

.dashboard-tiles {
	display: grid;
	grid-template-columns: 1fr;
}

.thumbnail iframe {
	width: 300%;
	height: 1500px;
}

.thumbnail {
  position: relative;
  -ms-zoom: 0.33;
  -moz-transform: scale(0.33);
  -moz-transform-origin: 0 0;
  -o-transform: scale(0.33);
  -o-transform-origin: 0 0;
  -webkit-transform: scale(0.33);
  -webkit-transform-origin: 0 0;
}

.thumbnail:after {
  content: "";
  display: block;
  width: 300%; height: 1500px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.thumbnail-container {
  width: 100%; height: 426px;
  margin: 0 auto;
  display: block;
  overflow: hidden;
  position: relative;
}
</style>
